import React, { Fragment, useEffect, useReducer, useState } from 'react';
import styled from 'styled-components/macro';
import find from 'lodash/find';
import get from 'lodash/get';
import filter from 'lodash/filter';
/* global google */

import Map from './Map';
import CategoryMenu from './CategoryMenu';
import LocationMarker from './LocationMarker';
import LocationInfo from './LocationInfo';


const LocationMap = ({ locations, home, categories, defaultCategory = null, zoom = 15, center, options, apiKey }) => {
    const [ googleMap, setGoogleMap ] = useState(null);
    const [ activeLocation, setActiveLocation ] = useState(null);
    
    const [ currentCategory, updateCurrentCategory ] = useReducer(
        (state, { categoryID }) => (
            categoryID ?
                { id: categoryID, locations: getCategoryLocations(categoryID, locations) }
                :
                { id: null, locations: null }
        ),
        { id: defaultCategory, locations: getCategoryLocations(defaultCategory, locations) }
    );
    
    useEffect(() => {
        if (currentCategory.locations && googleMap && google) {
            const bounds = new google.maps.LatLngBounds();
            
            currentCategory.locations.forEach((location) => {
                bounds.extend(location.acf.position);
            });
            
            if (home) bounds.extend(home.position);

            setActiveLocation(null);
            
            googleMap.fitBounds(bounds);
        }
    }, [ currentCategory, googleMap, home, setActiveLocation ]);
    
    
    const handleCategoryChange = (categoryID) => {
        updateCurrentCategory({ categoryID });
    };
    const handleMarkerClick = (locationID) => {
        if (locationID === activeLocation) {
            setActiveLocation(null);
        } else {
            setActiveLocation(locationID);
        }
    };
    
    return (
        <Container>
            <CategoryMenuWrapper>
                <CategoryMenu
                    categories={categories}
                    defaultCategory={defaultCategory}
                    onChange={handleCategoryChange}
                />
            </CategoryMenuWrapper>
        
            <MapWrapper>
                <Map
                    onLoad={setGoogleMap}
                    zoom={zoom}
                    center={center}
                    options={{ ...options, disableDefaultUI: true, maxZoom: 17 }} 
                    onClick={() => setActiveLocation(null)}
                    apiKey={apiKey}
                >
                    {home && (
                        <LocationMarker
                            key="home"
                            position={home.position}
                            icon={home.icon}
                            showInfo={false}
                            visible
                            clickable={false}
                            width={50}
                        />
                    )}
                
                    {locations.map((location) => (
                        <Fragment key={location.id}>
                            {location.id === activeLocation && (
                                <LocationInfo location={location}/>
                            )}
                        
                            <LocationMarker
                                id={location.id}
                                position={location.acf.position}
                                icon={location.acf.icon || getCategoryIcon(location, categories)}
                                visible={isLocationInCategory(location, currentCategory.id)}
                                onClick={handleMarkerClick}
                                width={30}
                                centerIcon={true}
                            />
                        </Fragment>
                    ))}
                </Map>
            </MapWrapper>
        </Container>
    );
};


export default LocationMap;


function isLocationInCategory(location, category) {
    return location.location_categories.indexOf(category) !== -1;
}

function getCategoryLocations(category, locations) {
    if (category) {
        return filter(locations, (location) => isLocationInCategory(location, category));
    } else {
        return null;
    }
}

function getCategoryIcon(location, categories) {
    const cat = find(categories, { id: location.location_categories[0] });
    
    return get(cat, 'acf.icon', null);
}


const Container = styled.div`
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    overflow: hidden;
`;

const CategoryMenuWrapper = styled.div`
    position: absolute;
    z-index: 2;
    bottom: 2rem;
    left: 50%;
    transform: translateX(-50%);
`;

const MapWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 0;
`;
